import type {CandidateEvaluationAction} from 'src/action-creators/candidate-evaluation';
import type {CandidateEvaluationState} from 'src/types/candidate-evaluation';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {
  RECEIVE_CANDIDATE_EVALUATION_INFO,
  UPDATE_CANDIDATE_EVALUATION_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET_CANDIDATE_EVALUATION_INFO,
} from 'src/action-creators/candidate-evaluation';


const initialState = {
  transcript: null,
  transcript_source: 'voice_ai_call',
  conversation_id: null,
  job_id: null,
  job_title: null,
  job_description: null,
  recipient_entity_id: null,
  resume: null,
  ...getDefaultNodeScheduleState({}),
} as const;

export default (
  state: CandidateEvaluationState | null | undefined = initialState,
  action: CandidateEvaluationAction,
): CandidateEvaluationState => {
  switch (action.type) {
    case RECEIVE_CANDIDATE_EVALUATION_INFO:
      // @ts-expect-error - TS2322 - Type '{ job_id?: string | null | undefined; job_title?: string | null | undefined; job_description?: string | null | undefined; transcript?: string | null | undefined; transcript_source?: string | null | undefined; ... 16 more ...; skip_frequency_check?: boolean; }' is not assignable to type 'CandidateEvaluationState'.
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_CANDIDATE_EVALUATION_INFO:
      // @ts-expect-error - TS2322 - Type '{ job_id?: string | null | undefined; job_title?: string | null | undefined; job_description?: string | null | undefined; transcript?: string | null | undefined; transcript_source?: string | null | undefined; ... 16 more ...; skip_frequency_check?: boolean; }' is not assignable to type 'CandidateEvaluationState'.
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      // @ts-expect-error - TS2322 - Type '{ date_type?: string; date_value?: string; time_type?: string; time_value?: string; offset?: number; date_field?: string | null | undefined; time_field?: string | null | undefined; dateOffset?: Offset; ... 13 more ...; conversation_id?: string | null | undefined; }' is not assignable to type 'CandidateEvaluationState'.
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CANDIDATE_EVALUATION_INFO:
      return {...initialState};
  }
  // @ts-expect-error - TS2322 - Type 'CandidateEvaluationState | null' is not assignable to type 'CandidateEvaluationState'.
  return state;
};
